import React from 'react';


export const Flask = props => {
    return (
        <img className={props.className} src={require('../../../resources/images/png_icons/flask.png')} />
    )
};
